import { CommonService } from "../../../../../services/CommonService";
import Language from "../../components/Language";
import { order } from "../SmartSearchParammeter";

export default async function LanguageLevelSearchConfig(key) {
  let languageLevels = await CommonService.getAllLanguageLevels();
  return {
    description: "Language",
    id: "languageLevels",
    initial: [],
    type: order.second,
    handleValues: (searchObject) => {
      searchObject.languageLevels = searchObject.languageLevels.map(
        (l) => l.id
      );
    },

    Component: (searchObject, setSearchObject, onChange, t) => (
      <div className="col-6 mt-2">
        {" "}
        <Language
          searchObject={searchObject}
          onChange={onChange}
          t={t}
          errors={{}}
        />
      </div>
    ),
    operation: ["Must"],
    list: languageLevels.map((l) => l.description.replace(/,/g, "#").trim()),
    examples: [
      `Natural Language: "I want a developer that speaks English at an advanced level\nStructured Query: "${key} Must B1"`
    ],
    handler: function (searchObj, value) {
      let languageLevelIndex = languageLevels.findIndex(
        (l) => value[0] === l.description.replace(/,/g, "#").trim()
      );
      searchObj["languageLevels"] = languageLevels.slice(
        languageLevelIndex,
        languageLevels.length
      );
    }
  };
}
